import { LOGIN_SUCCESSFUL,LOGOUT,CHANGED_PASSWORD } from "../constants";
const storedToken = localStorage.getItem("token") || null;
const storedUserId = localStorage.getItem("userId") || null;
const storedPerfilId = localStorage.getItem("perfil") || null;
const storedNombre = localStorage.getItem("nombre") || null;
const storedApellido = localStorage.getItem("apellido") || null;
const storedUsername = localStorage.getItem("username") || null;
const storedIsProvisional = localStorage.getItem("is_clave_provisional") || null;
const storedEmpresaId = localStorage.getItem("empresaId") || null;
// Parsea el valor de "is_clave_provisional" a un booleano
const storedIsProvisionalBoolean = storedIsProvisional === "true";
const initialState = {
  token: storedToken,
  userId: storedUserId,
  perfilId: storedPerfilId,
  nombre: storedNombre,
  apellido: storedApellido,
  username: storedUsername,
  is_clave_provisional: storedIsProvisionalBoolean,
  empresaId: storedEmpresaId,
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESSFUL:
      const { token, userId, perfilId,nombre,apellido,username,is_clave_provisional,empresaId} = action.payload;
      const nombreToSet = nombre !== undefined ? nombre : null;
      const apellidoToSet = apellido !== undefined ? apellido : null;
      const storedEmpresaId = empresaId;
      const parsedEmpresaId = storedEmpresaId === "null" || storedEmpresaId === null ? null : storedEmpresaId;
      
      // Guardar en localStorage al iniciar sesión
      localStorage.setItem("token", token);
      localStorage.setItem("userId", userId);
      localStorage.setItem("perfil", perfilId);
      localStorage.setItem("nombre", nombreToSet);
      localStorage.setItem("apellido", apellidoToSet);
      localStorage.setItem("username", username);
      localStorage.setItem("is_clave_provisional", is_clave_provisional);
      localStorage.setItem("empresaId", parsedEmpresaId);
      return {
        ...state,
        token: action.payload.token,
        userId: action.payload.userId,
        perfilId: action.payload.perfilId,
        nombre: nombreToSet,
        apellido: apellidoToSet,
        username: username,
        is_clave_provisional: is_clave_provisional,
        empresaId: parsedEmpresaId,
      };
    case LOGOUT:
      // Limpiar localStorage al cerrar sesión
      //localstorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("perfil");
      localStorage.removeItem("nombre");
      localStorage.removeItem("apellido");
      localStorage.removeItem("username");
      localStorage.removeItem("is_clave_provisional");
      localStorage.removeItem("empresaId");
      return {
        ...state,
        token: null,
        userId: null,
        perfilId: null,
        nombre: null,
        apellido: null,
        username: null,
        is_clave_provisional: null,
        empresaId: null,
      };
    case CHANGED_PASSWORD:
      const is_provisional = false;
      localStorage.setItem("is_clave_provisional", is_provisional);
      return {
        ...state,
        is_clave_provisional: is_provisional,
      };
    default:
      return state;
  }
};

export default authReducer;
